import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

const Certifications = ({ title, contentHTML, image }) => {
  return (
    <div style={{ padding: '30px 0 30px 0' }}>
      <center>
        <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
      </center>
      <div className="row">
        <div className="col-md-6">
          <div
            style={{
              padding: '0 15px 0 15px',
              fontFamily: 'Roboto',
              fontSize: 18,
              textAlign: 'justify',
              color: '#787878',
            }}
            dangerouslySetInnerHTML={{ __html: contentHTML }}
          />
        </div>
        <div className="col-md-6">
          <Img alt={image.title} sizes={image.sizes} />
        </div>
      </div>
    </div>
  );
};

Certifications.propTypes = {
  title: PropTypes.string.isRequired,
  contentHTML: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

export default Certifications;



// WEBPACK FOOTER //
// ./src/components/Main/about/Certifications.js